import type { AxiosResponse } from 'axios'
import type { ApiService } from '@/core/http/services/ApiService'
import type {
  CreatedPersonalAccessTokenResponse,
  PersonalAccessTokenCollectionResponse,
  PersonalAccessTokenRequest,
} from '@/core/http/services/tokens/types'

export default class PersonalAccessTokenService {
  constructor(private service: ApiService) {}

  public index(): Promise<AxiosResponse<PersonalAccessTokenCollectionResponse>> {
    return this.service.client.get('/api/tokens')
  }

  public store(
    request: PersonalAccessTokenRequest,
  ): Promise<AxiosResponse<CreatedPersonalAccessTokenResponse>> {
    return this.service.client.post('/api/tokens', request)
  }

  public destroy(tokenId: string): Promise<AxiosResponse> {
    return this.service.client.delete(`/api/tokens/${tokenId}`)
  }
}
